export let appMarket = ''

export const getAppData = (market) => {
  appMarket = market ? market.toLowerCase() : ''
}
